import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Transport extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, transport: {names: '', status: true}, visits: [], filteredVisits: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getTransport = this.getTransport.bind(this);
    this.getVisits = this.getVisits.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getProfileName = this.getProfileName.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getTransport();
    this.getVisits();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getTransport() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/transports/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({transport: resp.data});
    });
  }

  getVisits() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/visits/${id}/transport`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({visits: resp.data, filteredVisits: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/transports/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getTransport();
    });
  }

  handleSearch(event) {
    const visits = this.state.visits.filter(visit => {
      return visit.subject.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredVisits: visits});
  }

  getProfileName() {
    if('profile' in this.state.transport) {
      return this.state.transport.profile.names;
    } else {
      return 'Sin nombre';
    }
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/transports">Transportes</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.transport.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="car" />}
                  title={this.state.transport.name}
                />
                <p className={`cursor text-${Configuration.getStatus(this.state.transport.status).color}`} onClick={() => { this.handleStatus(this.state.transport.id) }}>{Configuration.getStatus(this.state.transport.status).text}</p>
                <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>{this.state.visits.length} visitas</p>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredVisits}
                renderItem={visit => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar icon="car" />}
                      title={<span>{visit.subject}</span>}
                      description={`Detalles ${visit.details}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Transport;



// WEBPACK FOOTER //
// ./src/pages/admin/Transport.js